export const userData = [
  {
    name: "Jan",
    "Active Orders": 4000,
  },
  {
    name: "Feb",
    "Active Orders": 3000,
  },
  {
    name: "Mar",
    "Active Orders": 5000,
  },
  {
    name: "Apr",
    "Active Orders": 4000,
  },
  {
    name: "May",
    "Active Orders": 3000,
  },
  {
    name: "Jun",
    "Active Orders": 2000,
  },
  {
    name: "Jul",
    "Active Orders": 4000,
  },
  {
    name: "Agu",
    "Active Orders": 3000,
  },
  {
    name: "Sep",
    "Active Orders": 4000,
  },
  {
    name: "Oct",
    "Active Orders": 1000,
  },
  {
    name: "Nov",
    "Active Orders": 4000,
  },
  {
    name: "Dec",
    "Active Orders": 3000,
  },
];

export const productData = [
  {
    name: "Jan",
    "Sales": 4000,
  },
  {
    name: "Feb",
    "Sales": 3000,
  },
  {
    name: "Mar",
    "Sales": 5000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 2,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 3,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 4,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 5,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 6,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 7,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 8,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 9,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
  {
    id: 10,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "S$120.00",
  },
];

export const productRows = [
  {
    id: 1,
    name: "Product 1",
    description: "Description of Product 1",
    img:
      "https://picsum.photos/200/300?random=1",
    stock: 100,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 2,
    name: "Product 2",
    description: "Description of Product 2",
    img:
      "https://picsum.photos/200/300?random=2",
    stock: 100,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 3,
    name: "Product 3",
    description: "Description of Product 3",
    img:
      "https://picsum.photos/200/300?random=3",
    stock: 13,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 4,
    name: "Product 4",
    description: "Description of Product 4",
    img:
      "https://picsum.photos/200/300?random=4",
    stock: 15,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 5,
    name: "Product 5",
    description: "Description of Product 5",
    img:
      "https://picsum.photos/200/300?random=5",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 6,
    name: "Product 6",
    description: "Description of Product 6",
    img:
      "https://picsum.photos/200/300?random=6",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 7,
    name: "Product 7",
    description: "Description of Product 7",
    img:
      "https://picsum.photos/200/300?random=7",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 8,
    name: "Product 8",
    description: "Description of Product 8",
    img:
      "https://picsum.photos/200/300?random=8",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 9,
    name: "Product 9",
    description: "Description of Product 9",
    img:
      "https://picsum.photos/200/300?random=9",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 10,
    name: "Product 10",
    description: "Description of Product 10",
    img:
      "https://picsum.photos/200/300?random=10",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 11,
    name: "Product 11",
    description: "Description of Product 11",
    img:
      "https://picsum.photos/200/300?random=9",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 12,
    name: "Product 12",
    description: "Description of Product 12",
    img:
      "https://picsum.photos/200/300?random=10",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 13,
    name: "Product 13",
    description: "Description of Product 13",
    img:
      "https://picsum.photos/200/300?random=13",
    stock: 13,
    status: "active",
    price: "S$1210.00",
  },
  {
    id: 14,
    name: "Product 14",
    description: "Description of Product 14",
    img:
      "https://picsum.photos/200/300?random=14",
    stock: 15,
    status: "active",
    price: "S$1120.00",
  },
  {
    id: 15,
    name: "Product 15",
    description: "Description of Product 15",
    img:
      "https://picsum.photos/200/300?random=15",
    stock: 123,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 16,
    name: "Product 16",
    description: "Description of Product 16",
    img:
      "https://picsum.photos/200/300?random=16",
    stock: 10,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 17,
    name: "Product 17",
    description: "Description of Product 17",
    img:
      "https://picsum.photos/200/300?random=17",
    stock: 12,
    status: "active",
    price: "S$120.00",
  },
  {
    id: 18,
    name: "Product 18",
    description: "Description of Product 18",
    img:
      "https://picsum.photos/200/300?random=18",
    stock: 130,
    status: "active",
    price: "S$1120.00",
  },


];

export const orderRows = [
  {
    id: 1,
    orderDate: '10/2/2021, 2:51:32 AM',
    imgUrl: "https://i.pravatar.cc/150?img=1",
    customer: "Adam Jane",
    address: "085 Bashirian Viaduct, Oranhaven, KY 87626",
    status: "Ordered",
    price: 110
  },
  {
    id: 2,
    orderDate: '9/26/2021, 1:05:18 PM',
    imgUrl: "https://i.pravatar.cc/150?img=2",
    customer: "Adrian",
    address: "334 Emmie Park, South Genevieveton, OR 90158",
    status: "Ordered",
    price: 91
  },
  {
    id: 3,
    orderDate: '9/25/2021, 10:29:23 AM',
    imgUrl: "https://i.pravatar.cc/150?img=3",
    customer: "Alexander",
    address: "89118 Nolan Freeway, Silasborough, WV 38105",
    status: "Delivered",
    price: 94.5
  },
  {
    id: 4,
    orderDate: '9/21/2021, 1:35:45 AM',
    imgUrl: "https://i.pravatar.cc/150?img=5",
    customer: "Brandon",
    address: "61879 Schuster Via, Berneiceburgh, GA 71035",
    status: "Cancelled",
    price: 438.9
  },
  {
    id: 5,
    orderDate: '9/20/2021, 3:07:50 PM',
    imgUrl: "https://i.pravatar.cc/150?img=4",
    customer: "Christopher",
    address: "801 Berge Wall, East Cassie, NE 30354-1300",
    status: "Ordered",
    price: 20
  },
  {
    id: 6,
    orderDate: '10/2/2021, 2:51:32 AM',
    imgUrl: "https://i.pravatar.cc/150?img=1",
    customer: "Adam Jane",
    address: "085 Bashirian Viaduct, Oranhaven, KY 87626",
    status: "Ordered",
    price: 110
  },
  {
    id: 7,
    orderDate: '9/26/2021, 1:05:18 PM',
    imgUrl: "https://i.pravatar.cc/150?img=2",
    customer: "Adrian",
    address: "334 Emmie Park, South Genevieveton, OR 90158",
    status: "Ordered",
    price: 91
  },
  {
    id: 8,
    orderDate: '9/25/2021, 10:29:23 AM',
    imgUrl: "https://i.pravatar.cc/150?img=3",
    customer: "Alexander",
    address: "89118 Nolan Freeway, Silasborough, WV 38105",
    status: "Delivered",
    price: 94.5
  },
  {
    id: 9,
    orderDate: '9/21/2021, 1:35:45 AM',
    imgUrl: "https://i.pravatar.cc/150?img=5",
    customer: "Brandon",
    address: "61879 Schuster Via, Berneiceburgh, GA 71035",
    status: "Cancelled",
    price: 438.9
  },
  {
    id: 10,
    orderDate: '9/20/2021, 3:07:50 PM',
    imgUrl: "https://i.pravatar.cc/150?img=4",
    customer: "Christopher",
    address: "801 Berge Wall, East Cassie, NE 30354-1300",
    status: "Ordered",
    price: 20
  },
  {
    id: 11,
    orderDate: '10/2/2021, 2:51:32 AM',
    imgUrl: "https://i.pravatar.cc/150?img=1",
    customer: "Adam Jane",
    address: "085 Bashirian Viaduct, Oranhaven, KY 87626",
    status: "Ordered",
    price: 110
  },
  {
    id: 12,
    orderDate: '9/26/2021, 1:05:18 PM',
    imgUrl: "https://i.pravatar.cc/150?img=2",
    customer: "Adrian",
    address: "334 Emmie Park, South Genevieveton, OR 90158",
    status: "Ordered",
    price: 91
  },
  {
    id: 13,
    orderDate: '9/25/2021, 10:29:23 AM',
    imgUrl: "https://i.pravatar.cc/150?img=3",
    customer: "Alexander",
    address: "89118 Nolan Freeway, Silasborough, WV 38105",
    status: "Delivered",
    price: 94.5
  },
  {
    id: 14,
    orderDate: '9/21/2021, 1:35:45 AM',
    imgUrl: "https://i.pravatar.cc/150?img=5",
    customer: "Brandon",
    address: "61879 Schuster Via, Berneiceburgh, GA 71035",
    status: "Cancelled",
    price: 438.9
  },
  {
    id: 15,
    orderDate: '9/20/2021, 3:07:50 PM',
    imgUrl: "https://i.pravatar.cc/150?img=4",
    customer: "Christopher",
    address: "801 Berge Wall, East Cassie, NE 30354-1300",
    status: "Ordered",
    price: 20
  },
  {
    id: 16,
    orderDate: '10/2/2021, 2:51:32 AM',
    imgUrl: "https://i.pravatar.cc/150?img=16",
    customer: "Adam Jane",
    address: "085 Bashirian Viaduct, Oranhaven, KY 87626",
    status: "Ordered",
    price: 1110
  },
  {
    id: 17,
    orderDate: '9/26/2021, 1:05:18 PM',
    imgUrl: "https://i.pravatar.cc/150?img=21",
    customer: "Adrian",
    address: "334 Emmie Park, South Genevieveton, OR 90158",
    status: "Ordered",
    price: 91
  },
  {
    id: 18,
    orderDate: '9/25/2021, 10:29:23 AM',
    imgUrl: "https://i.pravatar.cc/150?img=13",
    customer: "Alexander",
    address: "89118 Nolan Freeway, Silasborough, WV 38105",
    status: "Delivered",
    price: 94.5
  },
  {
    id: 19,
    orderDate: '9/21/2021, 1:35:45 AM',
    imgUrl: "https://i.pravatar.cc/150?img=15",
    customer: "Brandon",
    address: "61879 Schuster Via, Berneiceburgh, GA 71035",
    status: "Cancelled",
    price: 438.9
  },
  {
    id: 20,
    orderDate: '9/20/2021, 3:07:50 PM',
    imgUrl: "https://i.pravatar.cc/150?img=24",
    customer: "Christopher",
    address: "801 Berge Wall, East Cassie, NE 30354-1300",
    status: "Ordered",
    price: 220
  },

];

export const events = [
  {
    id: 1,
    color: 'green',
    from: '2021-10-01T00:00:00+00:00',
    to: '2021-10-02T05:00:00+00:00',
    title: 'Available'
  },
  {
    id: 2,
    color: 'red',
    from: '2021-10-01T13:00:00+00:00',
    to: '2021-10-02T14:00:00+00:00',
    title: 'This is another event'
  }, {
    id: 3,
    color: 'green',
    from: '2021-10-07T01:00:00+00:00',
    to: '2021-10-10T02:00:00+00:00',
    title: 'This is also another event'
  }
  , {
    id: 4,
    color: 'orange',
    from: '2021-10-07T01:00:00+00:00',
    to: '2021-10-09T02:00:00+00:00',
    title: 'This is testing event'
  }

];

export const reviews = [
  {
    id: "1",
    date: "2021-09-30",
    customer: "Lorine Medhurst",
    imgUrl: "https://i.pravatar.cc/150?img=1",
    product: "Purple Petunia",
    rating: "3",
    comment: "Perspiciatis vitae voluptas ab iusto et et minus iusto. Hic reiciendis modi unde. Vel neque ab quisquam sed voluptatibus maxime.\n \nQuibusdam voluptas similique voluptatem eaque. Velit ex eveniet id dolor ipsum. Perferendis magni qui adipisci eligendi delectus sit aut.\n \nOptio sint voluptates modi corporis eligendi omnis inventore. Est nobis soluta esse.\n \nQui perferendis et eos sunt. Reiciendis rem mollitia eligendi voluptatum quaerat recusandae velit.\n \nEt soluta ea cum quis ut. Quasi laboriosam est."
  },
  {
    id: "2",
    date: "2021-09-26",
    customer: "Caleigh Pagac",
    imgUrl: "https://i.pravatar.cc/150?img=2",
    product: "Pedestrian Crossing",
    rating: "2",
    comment: "Reiciendis earum est animi asperiores aspernatur officiis odit. Est velit magnam provident. Labore doloribus aut velit dolore iusto. Molestiae placeat harum non in minima sint. Error et ut aperiam quidem distinctio illo et. Ut veniam inventore ad.\n \nOfficia aut accusantium quia sapiente ut tempore porro. Magnam vel qui atque nobis quaerat veniam. Qui consectetur voluptatum mollitia vel eveniet. Rem omnis eum assumenda. Iusto beatae fuga minima. Cupiditate omnis est quo est illum et accusantium et iusto.\n \nTempore eum recusandae odit laboriosam ut sit praesentium necessitatibus magnam. Voluptatibus corporis officiis fuga similique. Pariatur repellendus rerum. Quae veniam inventore culpa voluptatem ut laudantium animi repellendus repellendus."
  },
  {
    id: "3",
    date: "2021-09-22",
    customer: "Kennedi Wunsch",
    imgUrl: "https://i.pravatar.cc/150?img=3",
    product: "White Peony",
    rating: "2",
    comment: "Rerum dolorem qui consequatur consectetur saepe labore quam. Cumque excepturi iste. Sequi iste molestiae expedita aut quia. Qui autem enim.\n \nSed quis fugiat. Harum reprehenderit temporibus nulla incidunt. Blanditiis officia non placeat mollitia. Qui id velit. Eum quasi molestiae. Maiores et occaecati et.\n \nReiciendis animi officia. Repudiandae et architecto assumenda. Pariatur nihil labore voluptatem. Fugit labore aut reiciendis dignissimos distinctio fuga sunt et dolores. Adipisci cum qui. Optio quia ipsam cumque officia fugit odio.\n \nMagnam necessitatibus consequatur velit dolorem atque aut. Saepe est natus consequatur pariatur. Nihil deleniti non placeat omnis voluptatem. Ut veniam tenetur dolorem vel ut beatae est. Temporibus atque perspiciatis qui est.\n \nQui asperiores vel est impedit numquam aliquam totam maiores. Aut qui suscipit vero et. Ullam provident quis qui nam veritatis et ipsam commodi at."
  },
  {
    id: "4",
    date: "2021-09-21",
    customer: "Toni Lesch",
    imgUrl: "https://i.pravatar.cc/150?img=4",
    product: "Pedestrian Crossing",
    rating: "2",
    comment: "At rerum enim omnis minima. Et et error voluptate labore. Unde minus nihil atque voluptate. Et ipsa quae at nobis fuga enim. Quasi illo saepe ea sit rem maiores nihil at magnam.\n \nLaboriosam unde sapiente voluptates ipsum quia atque accusantium et. Optio saepe earum eius quibusdam sunt. Velit ipsum ullam incidunt minima ab qui. Molestiae quos accusamus necessitatibus perspiciatis rerum qui omnis explicabo.\n \nEt voluptas quae incidunt vel. Quis totam debitis placeat aspernatur id id illo ipsam. Dolore ipsa laudantium veniam ipsa et. Laborum quo et.\n \nMinima cumque et dignissimos et. Eligendi eum eos minus esse deserunt culpa non cumque corrupti.\n \nAnimi sunt provident qui. Autem nesciunt incidunt ad magnam eum. Delectus et nesciunt veritatis quo aut est voluptatem."
  },
  {
    id: "5",
    date: "2021-09-21",
    customer: "Caleigh Pagac",
    imgUrl: "https://i.pravatar.cc/150?img=5",
    product: "Dining Hall",
    rating: "3",
    comment: "Quis voluptatem impedit sunt quia itaque. Illo iure laboriosam. Architecto ut error.\n \nCum similique vitae totam. Similique qui eos voluptatem sunt voluptate odit. Quam ex et mollitia fugiat maxime veritatis dolorem repellat. Officiis a enim. Aliquam doloribus architecto consequatur eos consequatur animi. Aut exercitationem sit a voluptatem natus quisquam."
  },
  {
    id: "6",
    date: "2021-09-20",
    customer: "Tobin Dare",
    imgUrl: "https://i.pravatar.cc/150?img=6",
    product: "Pedestrian Crossing",
    rating: "2",
    comment: "Ratione reprehenderit animi ipsum repudiandae et recusandae optio. Id sit qui qui. Voluptatum dignissimos exercitationem sint.\n \nLaboriosam facere rerum quisquam hic maiores ut. Magni iste facilis mollitia culpa quaerat non. Est vero minus illo omnis deleniti. Maiores repellendus esse qui provident velit vero reiciendis sapiente. Repellat unde quis omnis voluptates necessitatibus animi. Quia ipsam sunt.\n \nEt dolores ab commodi impedit sit quo harum suscipit. Maxime at assumenda eum suscipit.\n \nDolorem consequuntur omnis quia id possimus. Recusandae accusamus officiis fuga eligendi qui deleniti. Expedita corporis ut qui sed nihil. Sint perspiciatis veritatis placeat officiis expedita nostrum omnis ab aut."
  },
  {
    id: "7",
    date: "2021-09-15",
    customer: "Akeem Beatty",
    imgUrl: "https://i.pravatar.cc/150?img=7",
    product: "Music & Light",
    rating: "1",
    comment: "Temporibus non hic veniam. Veritatis ut eius dolor aut delectus accusamus. Et aut quam et ut modi et. Eos unde sequi ratione. Consectetur dolores voluptas quibusdam qui dolorem. Quasi quidem quo.\n \nIncidunt qui reprehenderit et quo in recusandae beatae. Culpa eveniet aliquam voluptas. Aliquam placeat ea laudantium earum reiciendis. Magnam quasi et repellat.\n \nVoluptas suscipit sed distinctio in tempore a sequi. Delectus dolores voluptatem quibusdam in adipisci et. Qui veritatis et dignissimos perferendis voluptatem dolorem ex aut. Modi velit illo eligendi ad dolor."
  },
  {
    id: "8",
    date: "2021-09-13",
    customer: "Renee Bauch",
    imgUrl: "https://i.pravatar.cc/150?img=8",
    product: "White Peony",
    rating: "4",
    comment: "Dolorum ullam voluptatum doloribus eos. Et repellendus qui ut ut dolorem qui non dolorem ipsam. Exercitationem voluptate voluptas doloribus qui voluptatum dolores illum nobis. Porro autem qui sit explicabo amet.\n \nQuos tenetur sint numquam velit eaque est cupiditate non dolore. Reprehenderit voluptatem qui et. Doloremque qui omnis officia. Et adipisci accusantium in quis qui."
  },
  {
    id: "9",
    date: "2021-09-12",
    customer: "Akeem Beatty",
    imgUrl: "https://i.pravatar.cc/150?img=9",
    product: "Pedestrian Crossing",
    rating: "4",
    comment: "Dolorem recusandae aperiam sunt quo minus autem velit culpa provident. Et iure voluptatum officia itaque eos exercitationem. Velit qui labore facilis veniam molestiae iure. Incidunt eos blanditiis dolorem eveniet at aut velit. Et reiciendis quibusdam ullam ut est non fugit qui.\n \nQui itaque quibusdam reprehenderit quasi voluptate. Nobis voluptas rerum optio.\n \nCupiditate magnam asperiores saepe dolor debitis exercitationem maxime similique ipsam. Minus sunt deserunt laudantium aliquid voluptatem ab consequatur consequatur. Ut officiis ea et perferendis est nobis nostrum fugit. Sunt delectus sed amet.\n \nAdipisci nihil numquam ipsa voluptatem ad. Dolorem quia commodi quas est praesentium.\n \nEveniet sunt voluptatem soluta. Aut illo id delectus. Ipsa mollitia facilis praesentium eum sapiente vero quod molestiae neque. Error veniam aut illum. Neque qui consequatur et praesentium perspiciatis. Mollitia necessitatibus consectetur quia."
  },
  {
    id: "10",
    date: "2021-09-12",
    customer: "Lorine Medhurst",
    imgUrl: "https://i.pravatar.cc/150?img=10",
    product: "Kick Flip",
    rating: "4",
    comment: "Ullam voluptatem fugiat minima quod quia. Omnis non delectus qui quisquam nihil eaque sit velit. Consequatur ipsam enim consequatur eum dolore. Et perferendis hic ut omnis. Dolorem dolorem at ex qui libero enim quia. Est assumenda iure quaerat sapiente sit deleniti praesentium.\n \nOdit quidem totam odit. Molestias facere distinctio unde soluta quasi perferendis repellat nam rerum.\n \nEt perspiciatis praesentium. Ut veritatis minus aliquid provident voluptatem quo. Iste est sunt. Vel eligendi aliquid error."
  },
  {
    id: "11",
    date: "2021-09-09",
    customer: "Renee Bauch",
    imgUrl: "https://i.pravatar.cc/150?img=11",
    product: "Plane Trees",
    rating: "1",
    comment: "Odit labore dolores est qui numquam. Qui voluptates ipsam vel provident est nam fugit. Officiis velit optio omnis quia dolores. Alias quis consequuntur ex temporibus enim rerum in hic.\n \nVel laboriosam rerum rerum omnis. Aliquid dolorem dolorum. Excepturi dolores exercitationem molestiae culpa fugiat molestiae reiciendis.\n \nDolor qui voluptas quos molestias porro facere sed et explicabo. Fugit rerum perferendis quos enim. Omnis quo omnis quia ut id voluptatum in."
  },
  {
    id: "12",
    date: "2021-09-04",
    customer: "Ashlee Fritsch",
    imgUrl: "https://i.pravatar.cc/150?img=12",
    product: "White Peony",
    rating: "1",
    comment: "Deserunt et eligendi esse quos necessitatibus accusantium inventore quam corrupti. Commodi odit consectetur sint fugiat aut facilis rerum dolorem ipsa.\n \nAdipisci molestias ab voluptatibus enim. Dolorem aut facilis. Quia nobis esse distinctio eum aut qui.\n \nNemo velit ut id. Rerum neque aut ea."
  },
  {
    id: "13",
    date: "2021-08-31",
    customer: "Renee Bauch",
    imgUrl: "https://i.pravatar.cc/150?img=13",
    product: "Kick Flip",
    rating: "2",
    comment: "Sit quia suscipit ex aut omnis recusandae delectus velit. Minima deserunt magni sint cupiditate accusantium dolor numquam. Voluptatem inventore deserunt quaerat. Tempore reprehenderit similique maxime ipsa.\n \nRecusandae dolore voluptas ad quia dolores officiis exercitationem porro. Sint qui perspiciatis ut rerum aliquam qui. Quibusdam autem vero enim est fugiat laborum soluta laboriosam sequi. Accusantium deserunt architecto voluptatem. Consequatur et tempore mollitia perspiciatis beatae. Recusandae nihil modi placeat."
  },
  {
    id: "14",
    date: "2021-08-31",
    customer: "Akeem Beatty",
    imgUrl: "https://i.pravatar.cc/150?img=14",
    product: "Kick Flip",
    rating: "3",
    comment: "Amet incidunt est quas. Magnam beatae voluptates dolores itaque consequatur. Quo commodi fugiat reiciendis aut.\n \nDolor sed ipsa. Est placeat temporibus sapiente officiis et veritatis perspiciatis quibusdam aperiam. Aliquid veniam quod est doloremque perspiciatis dolorem.\n \nDolores quisquam repellat reprehenderit quia fuga enim. Mollitia occaecati molestiae consequatur consectetur vitae ut nobis. Sapiente cumque qui commodi sit voluptates consequatur voluptatem. Maxime nam laborum eum expedita deleniti labore suscipit quam laboriosam. Ut rem exercitationem magnam possimus eum harum itaque. Nemo illum sunt atque nam quam et sint.\n \nPlaceat aut voluptatem culpa quia temporibus consequatur magni necessitatibus. Ut natus cumque voluptatem. Sed sequi vero deleniti autem dolorem consequuntur dolore facere sed. Temporibus doloremque odit nisi officia culpa magnam.\n \nOmnis dolorum voluptates quae perferendis ipsum quis quod debitis. Commodi neque autem dolores illum numquam voluptatem voluptas."
  },
  {
    id: "15",
    date: "2021-08-31",
    customer: "Savanah Blanda",
    imgUrl: "https://i.pravatar.cc/150?img=15",
    product: "Apricot Tree",
    rating: "3",
    comment: "Veritatis commodi non inventore accusantium exercitationem dolore reiciendis molestias. Itaque aut est voluptatem eligendi sit quisquam est velit pariatur. Sit rerum voluptatem suscipit quis distinctio voluptas. Voluptate cum quaerat aut eveniet consequatur fugit rerum dicta. Est illo magni possimus vitae est ipsa non ut aspernatur. Ducimus aut delectus doloremque."
  },
  {
    id: "16",
    date: "2021-08-28",
    customer: "Jeromy Turner",
    imgUrl: "https://i.pravatar.cc/150?img=16",
    product: "Kick Flip",
    rating: "1",
    comment: "Alias voluptatum aut architecto. Molestiae autem eligendi."
  },
  {
    id: "17",
    date: "2021-08-28",
    customer: "Jeromy Turner",
    imgUrl: "https://i.pravatar.cc/150?img=17",
    product: "Distant Mountains",
    rating: "3",
    comment: "Et id sit perferendis sed cum blanditiis laudantium. Assumenda illo molestias consequatur eos magnam consequatur velit culpa."
  },
  {
    id: "18",
    date: "2021-08-28",
    customer: "Savanah Blanda",
    imgUrl: "https://i.pravatar.cc/150?img=19",
    product: "White Peony",
    rating: "4",
    comment: "In cum atque id consectetur. Quae mollitia autem numquam facere placeat optio. Occaecati suscipit tempore incidunt vitae a illo amet et enim."
  },
  {
    id: "19",
    date: "2021-08-27",
    customer: "Renee Bauch",
    imgUrl: "https://i.pravatar.cc/150?img=20",
    product: "Phone Call",
    rating: "4",
    comment: "At harum sed. Amet voluptatem non molestiae ut impedit animi fugiat rerum fuga.\n \nNecessitatibus id magnam minima sunt. Nesciunt facilis at quae est suscipit sit. Ratione ducimus et.\n \nRecusandae aperiam corrupti illum odio. Aperiam aut est perspiciatis odio in. Aliquid explicabo consequatur explicabo adipisci nobis qui soluta hic occaecati. Fugit quis inventore rerum et voluptas voluptatem dolor quasi.\n \nQuis id eum hic eum molestias qui fugiat. Temporibus neque consequuntur. Dolore minus voluptas ea. Quia ipsa debitis molestias quia voluptas. Unde dicta quas soluta iste est. Aut deleniti aut sint amet magnam nemo.\n \nVoluptas itaque natus odit sequi dolores repellendus vero quia. Nisi pariatur odio est officiis."
  },
  {
    id: "20",
    date: "2021-08-27",
    customer: "Lorine Medhurst",
    imgUrl: "https://i.pravatar.cc/150?img=21",
    product: "Water Fall",
    rating: "3",
    comment: "Ut nostrum qui dolor laborum laborum et. Voluptatem eos tempora ratione sit illum voluptatem.\n \nMollitia quisquam ullam sapiente. Hic nam et eum. Labore alias aut beatae aliquam aliquid magnam earum. Quo reprehenderit qui perferendis rerum quis quis pariatur. Magni quis saepe occaecati consequuntur error cum ab possimus autem.\n \nA dolore consequuntur blanditiis hic alias. Mollitia aliquid minus et quia. Iste occaecati tempora ex. At ea saepe culpa fuga qui et praesentium eos animi. Molestiae nesciunt et."
  },
  {
    id: "21",
    date: "2021-08-22",
    customer: "Lorine Medhurst",
    imgUrl: "https://i.pravatar.cc/150?img=21",
    product: "White Peony",
    rating: "3",
    comment: "Qui dolorem laudantium ut consequatur iure non. Voluptate et commodi. Qui molestiae rerum non. Eum dolor voluptas. Maxime maxime laudantium id. Corrupti culpa ipsum."
  },
  {
    id: "22",
    date: "2021-08-17",
    customer: "Shyanne Mante",
    imgUrl: "https://i.pravatar.cc/150?img=22",
    product: "Water Fall",
    rating: "1",
    comment: "Et fuga et sit vel hic aspernatur. Inventore atque molestias natus molestias velit atque corrupti id quae. Qui aut quisquam aut incidunt eum non reprehenderit qui quaerat. Dolore odit eaque eum libero ab rerum.\n \nExcepturi atque pariatur sed. Sit modi velit et molestias molestiae qui asperiores repudiandae. Placeat quia aut sequi. Minus labore et nostrum delectus vel. Ea qui optio.\n \nEligendi id sit iusto. Id nesciunt quia at vel omnis facilis aut vel.\n \nEt ea voluptatem quidem aut. Ut iste inventore quasi. Id eos eum qui esse quia dolorem adipisci. Blanditiis et soluta corrupti tempora aut perferendis. Inventore nemo facere. Qui dolore ipsa accusantium beatae ea ducimus animi rerum.\n \nDolorem excepturi nobis. Qui et numquam ut sed sunt iusto voluptas. Exercitationem saepe quis. Saepe ab tenetur omnis sunt incidunt delectus est nulla."
  },
  {
    id: "23",
    date: "2021-08-07",
    customer: "Renee Bauch",
    imgUrl: "https://i.pravatar.cc/150?img=23",
    product: "Water Fall",
    rating: "3",
    comment: "Quasi optio perferendis accusamus aspernatur optio. Animi molestiae voluptatem autem dolor aut corporis porro ducimus. Omnis dolorum ullam cupiditate sit tempora est ducimus voluptatem.\n \nEaque excepturi voluptates vel sit illo quas laboriosam sed harum. Ea fugit neque ullam mollitia sunt velit inventore inventore. Saepe cum alias dolores magnam. Assumenda omnis eum veritatis suscipit voluptatem quas perspiciatis est. Et reiciendis voluptates vel ut tempora praesentium accusamus ex velit. Sint beatae voluptate quia hic accusamus voluptas."
  },
  {
    id: "24",
    date: "2021-07-30",
    customer: "Aurelie O'Connell",
    imgUrl: "https://i.pravatar.cc/150?img=24",
    product: "White Peony",
    rating: "3",
    comment: "Nihil vero velit et nesciunt alias esse. Fuga sint dicta voluptate repudiandae sint animi a. Architecto qui eum qui voluptas voluptas voluptatem quas velit. Tenetur ea officia modi."
  },
  {
    id: "25",
    date: "2021-07-30",
    customer: "Lorine Medhurst",
    imgUrl: "https://i.pravatar.cc/150?img=25",
    product: "Water Lily",
    rating: "2",
    comment: "Id illum in veritatis ut. Natus eius ea rerum natus.\n \nAccusamus porro cumque asperiores. Ipsam ratione omnis voluptatem quo.\n \nIusto quia iste dignissimos officia. Minus quisquam ipsam pariatur est reiciendis eius tempora nihil. Vero aut eum beatae ut consequatur error. Omnis est autem a repellendus est voluptatem dolorem. Quas repudiandae optio molestias aut assumenda. Nisi expedita ut voluptas deserunt aut."
  },
  {
    id: "26",
    date: "2021-07-27",
    customer: "Aurelie O'Connell",
    imgUrl: "https://i.pravatar.cc/150?img=26",
    product: "White Peony",
    rating: "1",
    comment: "Mollitia dolores qui qui voluptates corrupti eligendi eum quia. Nihil assumenda fugiat dolore sed animi quibusdam. Sit repellat consequatur dolores. Cum dignissimos odio et. Impedit occaecati eum facere velit. Iusto adipisci molestiae consequatur at.\n \nSit illum totam natus error aut quos sapiente ullam. Fuga aut hic harum sint qui. Fuga corrupti rerum vel.\n \nRepellendus debitis magnam accusantium sed. Esse repellat odio voluptas enim maiores voluptate earum at nostrum. Eligendi occaecati nesciunt repudiandae sint eligendi numquam sit et. Amet quo mollitia quia qui voluptates illum molestiae quae. Rem quasi iure natus hic illum.\n \nEt aliquam officiis distinctio architecto nobis illo. Voluptatem nostrum rerum facere suscipit pariatur tempore aspernatur. Non ea enim porro dolores sapiente dolor quas aut. Distinctio nulla assumenda officiis quos ipsa corporis et soluta ducimus."
  }
]